module.exports = __webpack_public_path__ + "static/media/Luxembourg.ef6cae0c.svg";